import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({ selector: '[appDateMask]' })
export class DateMaskDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.el.nativeElement;
    const formatted = this.formatDate(input.value);
    if (input.value !== formatted) {
      input.value = formatted;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const cd = event.clipboardData;
    const pasted = cd ? cd.getData('text') : '';
    if (!pasted) { return; }
    event.preventDefault();
    const input = this.el.nativeElement;
    input.value = this.formatDate(pasted);
    try {
      input.dispatchEvent(new Event('input', { bubbles: true } as any));
    } catch (e) {
      input.dispatchEvent(new Event('input'));
    }
  }

  private formatDate(value: string): string {
    const digits = (value || '').replace(/\D/g, '').slice(0, 8);
    const dd = digits.slice(0, 2);
    const mm = digits.slice(2, 4);
    const yyyy = digits.slice(4, 8);
    const parts: string[] = [];
    if (dd) { parts.push(dd); }
    if (mm) { parts.push(mm); }
    if (yyyy) { parts.push(yyyy); }
    return parts.join('/');
  }
}

